<template>
  <div>
    <BaseButton
      size="60"
      round
      icon_only
      default_icon="button-create_pdf"
      @click="onSave"
      :disabled="disabled"
    />
    <pdf-gen
      :content-data="contentData"
      :header-data="headerData"
      invisible
      landscape
      page-size="A3"
      ref="pdf"
      :name="localStorage.translations.pages.finance.pages.salary + String(period.term ? ' ' + period.term : '') + '.pdf'"
    />
  </div>
</template>

<script>
import PdfGen from "components/pdf/pdfGen";
import {mapMutations} from "vuex";

export default {
  name: "FinanceSalarySliceShowPdf",
  components: {PdfGen},
  props: {
    projects: {
      type: [Array, Object],
      default: () => {
        return null
      }
    },
    period: {
      type: Object,
      default: () => {
        return {}
      }
    },
    employees: {
      type: [Array, Object],
      default: () => {
        return []
      }
    },
    responsible: {
      type: [Array, Object],
      default: () => {
        return null
      }
    },
    disabled: Boolean,
    responsibleShowTotal: Boolean,
  },
  computed: {
    t() {
      return this.localStorage.translations.pages.finance['period-table']
    },
    headerData() {
      return [{
        style: 'header',
        table: {
          widths: ['*', 'auto', 'auto'],
          body: [[
            {
              image: 'logo',
              fit: [150, 60],
              margin: [15, 10, 10, 10],
            },
            {text: this.localStorage.translations.pages.finance.pages.salary, margin: [15, 35, 15, 10]},
            {text: this.period.term, margin: [15, 35, 15, 10]},
          ]]
        },
        layout: {
          hLineColor: '#d2d5d9',
          vLineWidth: function () {
            return 0
          },
          hLineWidth: function (i) {
            return i === 0 ? 0 : 0.25
          },
        },
      }]
    },
    checkResponsibleShow() {
      let result = {}
      let days =[]
      for (let e in this.employees) {
        result[e] = false
        let type = ['previous', 'current']
        for (let t in type) {
          if (this.employees[e][type[t]]) {
            days = this.$GetDaysByProjectsFinanceSalary(this.employees[e][type[t]])
            for (let d in days) {
              for (let p in days[d].projects) {
                let arr = ['work_types', 'extras']
                for (let a in arr) {
                  for (let w in days[d].projects[p][arr[a]]) {
                    for (let r in days[d].projects[p][arr[a]][w].reports) {
                      if (days[d].projects[p][arr[a]][w].reports[r] && days[d].projects[p][arr[a]][w].reports[r].responsible_user_id !== null){
                         result[e] = true
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return result;
    }
  },
  data: () => ({
    contentData: []
  }),
  methods: {
    ...mapMutations(['setLoadingAnimationFullPage']),
    onSave() {
      this.setLoadingAnimationFullPage(true)
      
      let positionPlus = 0
      if (this.projects) {
        let total = this.getHeaderLines()
        positionPlus = 0
        for (let i in this.projects) {
          let lines = this.getTotalTable(
            this.projects[i].name,
            this.projects[i].work_types,
            this.projects[i].extras,
            positionPlus
          )
          for (let i in lines) total.table.body.push(lines[i])
          positionPlus += Object.keys(this.projects[i]['work_types']).length +
            (Object.keys(this.projects[i]['extras']).length ? 1 : 0)
        }
        this.contentData.push(total)
      }
      let q = 0
      for (let e in this.employees) {
        q++
        let line = 0
        let temp = {
          style: ['text', 'lh12'],
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{
                style: 'black',
                fillColor: '#277faf',
                color: 'white',
                margin: [10, 12, 10, 12],
                columns: [
                  {text: this.t.employee + ': ' + this.employees[e].first_name + ' ' + this.employees[e].last_name},
                  {text: this.period.weeks ? this.t.weeks + ': ' + this.period.weeks : ''},
                  {text: this.period.term ? this.t.term + ': ' + this.period.term : ''},
                ],
              }],
              [this.getHeaderLines()]
            ],
          },
          layout: 'noBorders',
        }
        if (this.projects || q > 1) temp.pageBreak = 'before'
        positionPlus = 0
        for (let i in this.employees[e].projects) {
          if (this.employees[e].projects[i - 1])
            positionPlus += Object.keys(this.employees[e].projects[i - 1]['work_types']).length +
              (Object.keys(this.employees[e].projects[i - 1]['extras']).length ? 1 : 0)
          let lines = this.getTotalTable(
            this.employees[e].projects[i].name,
            this.employees[e].projects[i].work_types,
            this.employees[e].projects[i].extras,
            positionPlus
          )
          for (let l in lines) temp.table.body[1][0].table.body.push(lines[l])
          line += lines.length
        }
        let plusLine = 1
        let type = ['previous', 'current']
        for (let t in type) {
          if (this.employees[e][type[t]]) {
            plusLine = plusLine + 1
            let typeHeader = []
              typeHeader = [
                this.getHeaderLines(
                  true,
                  this.localStorage.translations.pages.finance['salary-table'][type[t] === 'previous' ? 'balance' : 'current'],
                  this.checkResponsibleShow[e]
                )
              ]
            temp.table.body.push(typeHeader)
            if (line === 23) temp.table.body[plusLine][0].pageBreak = 'before'
            let days = this.$GetDaysByProjectsFinanceSalary(this.employees[e][type[t]])
            for (let d in days) {
              let l = 0
              let pp = Object.values(days[d].projects)
              let lng = 0
              // === rows amount for brake page ===
              for (let p in pp) {
                if (pp[p].work_types) {
                  let rr = Object.values(pp[p].work_types).map(w => w.reports)
                  for (let r in rr) lng += rr[r].length
                }
                if (pp[p].extras) {
                  lng += 1
                  let rr = Object.values(pp[p].extras).map(w => w.reports)
                  for (let r in rr) lng += rr[r].length
                }
              }
              // === ===
              for (let p in days[d].projects) {
                let arr = ['work_types', 'extras']
                for (let a in arr) {
                  if (arr[a] === 'extras' && days[d].projects[p]['extras']) {
                    let bodyLines = [
                      {text: days[d].date, rowSpan: l === 0 ? lng : 1},
                      {text: days[d].projects[p].name, style: 'black'},
                      {
                        text: this.getSumByField(days[d].projects[p]['extras'], 'employee_report', true),
                        style: 'black'
                      },
                      {
                        text: this.getSumByField(days[d].projects[p]['extras'], 'approved_report', true),
                        style: 'black'
                      },
                      {text: this.getSumByField(days[d].projects[p]['extras'], 'paid_report', true), style: 'black'},
                      {text: '—', style: 'black'},
                      {text:
                          this.getNumSumByField(days[d].projects[p]['extras'], 'salary_sum', true)
                            ? this.$formatCurrency(this.getNumSumByField(days[d].projects[p]['extras'], 'salary_sum', true))
                            + ' €' : '—',
                        style: 'black'
                      },
                      {text: this.t['total-extra'], style: 'black', colSpan: 4},
                      '', '', '', ''
                    ]
                    if (this.checkResponsibleShow[e]) {
                      let cutTemp = bodyLines.slice(0, 7)
                      let newLines = [
                        {text: '—', style: 'black', fillColor: '#F4F4F4'},
                        {text: this.getNumSumByField(days[d].projects[p]['extras'], 'project_responsible_salary_sum',true)
                            ? this.$formatCurrency(this.getNumSumByField(days[d].projects[p]['extras'], 'project_responsible_salary_sum', true)) + ' €' : '—',
                          style: 'black', fillColor: '#F4F4F4'},
                        {text: Object.values(days[d].projects[p]['extras'])[0]['project_responsible_name']
                            ? Object.values(days[d].projects[p]['extras'])[0]['project_responsible_name']
                            : '—',
                          style: 'black', fillColor: '#F4F4F4'},
                        {text: this.t['total-extra'], style: 'black'},
                        ''
                      ]
                      bodyLines = cutTemp.concat(newLines)
                    }
                    temp.table.body[plusLine][0].table.body.push(bodyLines)
                    line += 1
                    l += 1
                  }
                  for (let w in days[d].projects[p][arr[a]]) {
                    for (let r in days[d].projects[p][arr[a]][w].reports) {
                      let style = ['lh12', arr[a] === 'extras' ? '' : 'black']
                      let info = this.getDataLine(
                        days[d].projects[p][arr[a]][w],
                        arr[a] === 'extras',
                        days[d].projects[p][arr[a]][w].reports[r]
                      )
                      let qq = [
                        {text: days[d].date, rowSpan: l === 0 ? lng : 1},
                        {text: days[d].projects[p].name, style},
                        {text: info[0], style},
                        {text: info[1], style, fillColor: info[10]},
                        {text: info[2], style, fillColor: info[11]},
                        {text: info[3], style},
                        {text: info[4], style},
                        {text: info[8], style, colSpan: 4},
                        {text: '', style}, {text: '', style}, {text: '', style},
                        {text: info[9], style},
                      ]
                      if (this.checkResponsibleShow[e]) {
                        qq = [
                          {text: days[d].date, rowSpan: l === 0 ? lng : 1},
                          {text: days[d].projects[p].name, style},
                          {text: info[0], style},
                          {text: info[1], style, fillColor: info[10]},
                          {text: info[2], style, fillColor: info[11]},
                          {text: info[3], style},
                          {text: info[4], style},
                          {text: info[5], style, fillColor: '#F4F4F4'},
                          {text: info[6], style, fillColor: '#F4F4F4'},
                          {text: info[7], style, fillColor: '#F4F4F4'},
                          {text: info[8], style},
                          {text: info[9], style},
                        ]
                      }
                      if (temp.table.body[plusLine])
                        temp.table.body[plusLine][0].table.body.push(qq)
                      line += 1
                      l += 1
                    }
                  }
                }
              }
            }
          }
        }
        this.contentData.push(temp)
      }
      
      if (this.responsibleShowTotal)
      this.contentData.push(this.getResponsibleTable())
      
      if (this.$refs.pdf) this.$refs.pdf.onDownload()
      
      setTimeout(() => {
        this.setLoadingAnimationFullPage(false)
      }, 1000)
      this.contentData = []
    },
    getResponsibleTable() {
      let result = []
      let header = {
        style: ['text'],
        table: {
          headerRows: 1,
          widths: [300, 200, 200],
          body: [
            [{
              text: this.localStorage.translations.pages['sales_project']['planned_resources-responsible_employees'].main,
              colSpan: 3,
              margin: [10, 12, 10, 12],
              border: [false, false, false, false],
              color: '#277faf',
              fillColor: 'white',
              style: 'black',
            }, '', ''],
            [
              {text: this.localStorage.translations.pages['setting-personal_area'].labels['imya'],  alignment: 'center'},
              {text: this.t['rate'],  alignment: 'center'},
              {text: this.t['premium'],  alignment: 'center'},
            ],
          ],
        },
        layout: {
          vLineColor: '#ebebeb',
          hLineColor: '#ebebeb',
          vLineWidth: function () {
            return 0.6
          },
          hLineWidth: function () {
            return 0.6
          },
          paddingTop: function () {
            return 6
          },
          paddingBottom: function () {
            return 4
          },
          fillColor: function (i) {
            return i === 0 || i === 1 ? '#f2f2f2' : null
          }
        },
      }
      let temp = []
      for (let resp in this.responsible) {
        if (this.responsible[resp].responsible.length > 0 ) {
          for (let r in this.responsible[resp].responsible) {
              let p = this.responsible[resp].responsible[r]
              temp.push(
                {text: p['responsible_user_first_name'] ? this.responsible[resp].responsible[r]['responsible_user_first_name'] + ' ' + this.responsible[resp].responsible[r]['responsible_user_last_name'] : '—', style: 'text'},
                {text: p['project_responsible_salary_sum'] ? this.$formatCurrency(this.responsible[resp].responsible[r]['project_responsible_salary_sum']) + ' €' : '—', style: 'text'},
                {text: p['project_responsible_salary_sum_approved'] ? this.$formatCurrency(this.responsible[resp].responsible[r]['project_responsible_salary_sum_approved']) + ' €' : '—', style: 'text'}
              )}
          header.table.body.push(temp)
        }
        temp = []
      }
      header.pageBreak = 'before'
      result.push(header)
      return result
    },
    getTotalTable(project, work_types, extras, positionPlus) {
      let result = []
      let arr = {work_types: work_types, extras: extras}
      for (let a in arr) {
        let extraPosition = positionPlus + Object.keys(work_types).length + 1
        if (a === 'extras' && Object.keys(extras).length)
          result.push([
            {text: extraPosition, style: 'black'},
            {text: project, style: 'black'},
            {text: this.getSumByField(arr[a], 'employee_report'), style: 'black'},
            {text: this.getSumByField(arr[a], 'approved_report'), style: 'black'},
            {text: this.getSumByField(arr[a], 'paid_report'), style: 'black'},
            {text: '—', style: 'black'},
            {text:
                this.getNumSumByField(arr[a], 'salary_sum')
                  ? this.$formatCurrency(this.getNumSumByField(arr[a], 'salary_sum')) + ' €' : '—',
              style: 'black'},
            {text: this.t['total-extra'], colSpan: 4, style: 'black'}, '', '', '',
          ])
        let works = Object.values(arr[a])
        for (let w in works) {
          let info = this.getDataLine(works[w], a === 'extras')
          let style = ['lh12', a === 'extras' ? '' : 'black']
          result.push([
            {
              text: a === 'extras'
                ? extraPosition + '.' + Number(Number(w) + 1)
                : positionPlus + Number(w) + 1,
              style
            },
            {text: project, style},
            {text: info[0], style},
            {text: info[1], style},
            {text: info[2], style},
            {text: info[3], style},
            {text: info[4], style},
            {text: info[5], style, colSpan: 4},
          ])
        }
      }
      return result
    },
    getHeaderLines(byDays, title, responsibleShow) {
      let result = {
        style: 'text',
        table: {
          headerRows: 2,
          widths: [45, 125, 75, 65, 65, 75, 65, 65, 65, 125, '*'],
          body: [],
        },
        layout: {
          vLineColor: '#ebebeb',
          hLineColor: '#ebebeb',
          vLineWidth: function () {
            return 0.6
          },
          hLineWidth: function () {
            return 0.6
          },
          paddingTop: function () {
            return 6
          },
          paddingBottom: function () {
            return 4
          },
          fillColor: function (i) {
            return i === 0 || i === 1 ? '#f2f2f2' : null
          }
        }
      }
      if (title || byDays) {
        result.table.headerRows = 3
        result.table.body.push([
          {
            text: title,
            colSpan: 12,
            margin: [6, 4, 6, 6],
            border: [false, false, false, false],
            color: '#277faf',
            style: 'black',
          }, '', '', '', '', '', '', '', '', '', '', '',
        ])
        result.layout.fillColor = function (i) {
          return i === 1 || i === 2 ? '#f2f2f2' : null
        }
      }
      let temp = [
        [
          {text: byDays ? this.t.date : this.t.position, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0]},
          {text: this.t.project, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0]},
          {text: this.t['reported'], alignment: 'center'},
          {text: this.t['invoiced'], alignment: 'center'},
          {text: this.t['pay'], alignment: 'center'},
          {text: this.t['rate'], alignment: 'center'},
          {text: this.localStorage.translations.pages.finance['invoice-table']['sum'], alignment: 'center'},
          {text: this.t.work, rowSpan: 2, colSpan: 4, margin: [10, 10, 0, 0]}, '', '', '',
        ],
        ['', '', {text: this.t.quantity, colSpan: 5, alignment: 'center'}, '', '', '', '', '', '', '', '',]
      ]
      if (responsibleShow) {
        let dividerTop = temp[0].slice(0,7)
        let dividerBottom = temp[1].slice(0,7)
        let responsibleShowDataTop = [
          {text: this.localStorage.translations.pages['sales_project']['planned_resources-responsible_employees'].main , colSpan: 3, alignment: 'center', fillColor: '#E4E4E4'}, '', '',
          {text: this.t.work, rowSpan: 2, margin: [10, 10, 0, 0]},
        ]
        let responsibleShowDataBottom = [
          {text: this.t['rate'], alignment: 'center', fillColor: '#E4E4E4'},
          {text: this.t['premium'], alignment: 'center', fillColor: '#E4E4E4'},
          {text: this.localStorage.translations.pages['setting-personal_area'].labels['imya'], alignment: 'center', fillColor: '#E4E4E4'},
          '',
        ]
        temp[0] = dividerTop.concat(responsibleShowDataTop)
        temp[1] = dividerBottom.concat(responsibleShowDataBottom)
      }
      if (byDays) {
        result.table.widths.push(100)
        temp[0].push({text: this.t.notes, rowSpan: 2, margin: [10, 10, 0, 0]})
        temp[1].push('')
      }
      result.table.body.push(temp[0])
      result.table.body.push(temp[1])
      return result
    },
    getDataLine(work, isExtra, report) {
      if (report)
        return [
          work.is_hourly === 1 || isExtra
            ? this.$formatTime(report['employee_report'])
            : this.formatNumber(report['employee_report']) + ' ' + work.measure,
          report['approved_report'] > 0
            ? work.is_hourly === 1 || isExtra
              ? this.$formatTime(report['approved_report'])
              : this.formatNumber(report['approved_report']) + ' ' + work.measure
            : '',
          report['paid_report'] > 0
            ? work.is_hourly === 1 || isExtra
              ? this.$formatTime(report ? report['paid_report'] : work['paid_report'])
              : this.formatNumber(report ? report['paid_report'] : work['paid_report']) + ' ' + work.measure
            : '',
          work.salary ? this.$formatCurrency(work.salary) + ' €/' + (work?.measure || this.localStorage.translations.pages.common.measure.hours_min) : '—',
          report['salary_sum'] ? this.$formatCurrency(report['salary_sum']) + ' €' : '—',
          report['project_responsible_salary'] ? this.$formatCurrency(report['project_responsible_salary']) + ' €/' + (work?.measure || this.localStorage.translations.pages.common.measure.hours_min) : '—',
          report['project_responsible_approved'] > 0 && report['project_responsible_salary_sum'] ? this.$formatCurrency(report['project_responsible_salary_sum']) + ' €' : '—',
          report['responsible_user_id'] ? report['responsible_user_first_name'] + ' ' + report['responsible_user_last_name'] : '—',
          work.name,
          report['salary_notes'],
          report['approved_report'] > report['employee_report']
            ? '#e8f5e9'
            : report['approved_report'] < report['employee_report'] && report['approved_report'] > 0
              ? '#ffebee' : null,
          report['paid_report'] > report['approved_report']
            ? '#e8f5e9'
            : report['paid_report'] < report['approved_report'] && report['paid_report'] > 0
              ? '#ffebee' : null,
        ]
      return [
        work.is_hourly === 1 || isExtra
          ? this.$formatTime(work['employee_report'])
          : this.formatNumber(work['employee_report']) + ' ' + work.measure,
        work['approved_report'] > 0
          ? work.is_hourly === 1 || isExtra
            ? this.$formatTime(work['approved_report'])
            : this.formatNumber(work['approved_report']) + ' ' + work.measure
          : '',
        work['paid_report'] > 0
          ? work.is_hourly === 1 || isExtra
            ? this.$formatTime(work['paid_report'])
            : this.formatNumber(work['paid_report']) + ' ' + work.measure
          : '',
        work.salary ? this.$formatCurrency(work.salary) + ' €/' + (work?.measure || this.localStorage.translations.pages.common.measure.hours_min) : '—',
        work['salary_sum'] ? this.$formatCurrency(work['salary_sum']) + ' €' : '—',
        work.name, '', '', '',
      ]
    },
    getSumByField(items, field, byDay) {
      if (byDay) {
        let temp = Object.values(items).map((data) => data.reports).reduce((sum, current) => {
          return (sum + current.reduce((sum, current) => {
            return sum + current[field]
          }, 0))
        }, 0)
        return temp ? this.$formatTime(temp) : ''
      }
      let result = Object.values(items).reduce((sum, current) => {
        return sum + current[field]
      }, 0)
      return result ? this.$formatTime(result) : ''
    },
    getNumSumByField(items, field) {
      const r = Object.values(items).map(d => d.reports).flat()
      if (r[0]) {
        return r.reduce((sum, current) => {
          return sum + current[field]
        }, 0)
      }
      return Object.values(items).reduce((sum, current) => {
        return sum + current[field]
      }, 0)
    },
    formatNumber(num) {
      return Math.round(num * 100) / 100
    },
  }
}
</script>